import React from 'react';
import { withTheme } from 'styled-components';
import { localize } from 'core/localization';
import { Figure } from './Figure.styled';

type StarRatingProps = {
  theme: { [key: string]: any };
};
const reverseStyle = { transformOrigin: '50%', transform: 'scale(-1,1)' };
export const StarRating = (props: StarRatingProps) => (
  <Figure
    width="260px"
    height="141px"
    viewBox="0 0 260 141"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    arialabel={`${localize('[aria label star rating]')}`}
    data-test="star-rating-icon"
  >
    <title>Star Rating icon</title>
    <desc>Created with sketchtool.</desc>
    <svg width="275" height="111" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(0 2)" fill="none" fillRule="evenodd">
        <ellipse
          fill={props.theme?.colors.textColor || '#363E4E'}
          fillRule="nonzero"
          opacity=".1"
          cx="137.5"
          cy="105.5"
          rx="34.5"
          ry="3.5"
        />
        <path
          d="M78.776 1.448h-56.58s-9.92 1.07-9.92 8.957c0 7.887 9.92 8.957 9.92
          8.957l33.663.064s7.878 1.535 7.878 8.445-7.878 8.957-7.878 8.957H38.467s-14.118.862-14.118
          9.405 14.118 9.853 14.118 9.853H10.026S0 57.813 0 64.979 10.026 74 10.026 74h219.858s12.378-1.408
          12.378-9.021c0-7.614-12.378-8.893-12.378-8.893h-21.497s-12.553-.748-12.777-8.51c-.224-7.76
          12.777-9.212 12.777-9.212l24.946-.864s13.021 1.92 13.021-8.861c0-10.78-11.979-9.277-11.979-9.277l29.883.064S275
          18.78 275 10.405 264.258 1 264.258 1l-185.482.448z"
          fillRule="nonzero"
          opacity=".02"
          fill={props.theme?.colors.textColor || '#363E4E'}
        />
        <path
          d="M167-1c4.694 0 8.944 1.903 12.02 4.98A16.947 16.947 0 0 1 184
          16v32.762c0 4.695-1.903 8.945-4.98 12.021a16.947 16.947 0 0 1-12.027
          4.98l-3.3-.048v18.64l-19.321-18.653-43.287.217a16.947 16.947 0 0
          1-12.045-4.918A16.95 16.95 0 0 1 84 49V16c0-4.694 1.903-8.944 4.98-12.02A16.947 16.947 0 0 1 101-1z"
          stroke={props.theme?.colors.correctColor || '#32C080'}
          strokeWidth="2"
          fill="#F5FCF8"
          fillRule="nonzero"
          style={(props.theme?.isRtl && reverseStyle) || undefined}
        />
        <path
          fill={props.theme?.colors.correctColor || '#32C080'}
          d="m106 39.31-7.348 3.862 1.403-8.182-5.944-5.794 8.215-1.193
          3.673-7.444 3.674 7.444 8.214 1.193-5.944 5.794 1.404 8.182zM134
          39.31l-7.348 3.862 1.403-8.182-5.944-5.794 8.215-1.193 3.673-7.444
          3.674 7.444 8.214 1.193-5.944 5.794 1.404 8.182z"
          style={(props.theme?.isRtl && reverseStyle) || undefined}
        />
        <path
          d="m162 22.367 3.142 6.367 7.026 1.021-5.084 4.956 1.2 6.998L162 38.405l-6.285 3.304 1.2-6.998-5.084-4.956 7.027-1.021 3.142-6.367z"
          stroke={props.theme?.colors.correctColor || '#32C080'}
          strokeWidth="1.6"
          fill={props.theme?.colors.contentBodyColor || '#FFF'}
          style={(props.theme?.isRtl && reverseStyle) || undefined}
        />
      </g>
    </svg>
  </Figure>
);

export default withTheme(StarRating);
